/**
 * admin-console タイポグラフィ定義
 * service-site と共通（Noto Sans JP, rem ベース）
 *
 * 基準: 16px = 1rem
 */
import { defineTokens, defineTextStyles } from '@chakra-ui/react';

export const fonts = defineTokens.fonts({
  body: { value: '"Noto Sans JP", system-ui, sans-serif' },
  heading: { value: '"Noto Sans JP", system-ui, sans-serif' },
});

/**
 * フォントサイズトークン（rem ベース）
 *
 * | Token   | REM      | PX   | 用途例                     |
 * |---------|----------|------|---------------------------|
 * | 2xs     | 0.625rem | 10px | 注釈、補足                 |
 * | xs      | 0.75rem  | 12px | ラベル、メタ情報           |
 * | sm      | 0.875rem | 14px | 補足本文、カード内テキスト |
 * | sm-md   | 0.9375rem| 15px | 見出し (Heading Small)    |
 * | md      | 1rem     | 16px | 本文 (Body Default)       |
 * | lg      | 1.0625rem| 17px | 見出し、強調本文           |
 * | lg-xl   | 1.125rem | 18px | ラベル (Label XL)         |
 * | xl      | 1.25rem  | 20px | 見出し                     |
 * | 2xl     | 1.5rem   | 24px | セクション見出し           |
 * | 3xl     | 1.75rem  | 28px | 大見出し                   |
 * | 4xl     | 2rem     | 32px | ヒーロー見出し             |
 */
export const fontSizes = defineTokens.fontSizes({
  '2xs': { value: '0.625rem' }, // 10px
  xs: { value: '0.75rem' }, // 12px
  sm: { value: '0.875rem' }, // 14px
  'sm-md': { value: '0.9375rem' }, // 15px
  md: { value: '1rem' }, // 16px
  lg: { value: '1.0625rem' }, // 17px
  'lg-xl': { value: '1.125rem' }, // 18px
  xl: { value: '1.25rem' }, // 20px
  '2xl': { value: '1.5rem' }, // 24px
  '3xl': { value: '1.75rem' }, // 28px
  '4xl': { value: '2rem' }, // 32px
});

export const fontWeights = defineTokens.fontWeights({
  normal: { value: '400' },
  medium: { value: '500' },
  bold: { value: '700' },
});

export const lineHeights = defineTokens.lineHeights({
  none: { value: '100%' },
  tight: { value: '120%' },
  snug: { value: '130%' },
  short: { value: '137.5%' },
  normal: { value: '150%' },
  relaxed: { value: '160%' },
  tall: { value: '162.5%' },
  loose: { value: '170%' },
});

/**
 * テキストスタイル定義
 */
export const textStyles = defineTextStyles({
  // Heading styles
  'heading.2xl': {
    value: {
      fontSize: '3xl',
      fontWeight: 'bold',
      lineHeight: '150%',
    },
  },
  'heading.xl': {
    value: {
      fontSize: '2xl',
      fontWeight: 'bold',
      lineHeight: '120%',
    },
  },
  'heading.lg': {
    value: {
      fontSize: 'xl',
      fontWeight: 'bold',
      lineHeight: '120%',
    },
  },
  'heading.md': {
    value: {
      fontSize: 'lg',
      fontWeight: 'bold',
      lineHeight: '120%',
    },
  },
  'heading.sm': {
    value: {
      fontSize: 'sm-md',
      fontWeight: 'bold',
      lineHeight: '120%',
    },
  },
  'heading.xs': {
    value: {
      fontSize: 'xs',
      fontWeight: 'bold',
      lineHeight: '120%',
    },
  },

  // Body styles
  'body.lg': {
    value: {
      fontSize: 'md',
      fontWeight: 'normal',
      lineHeight: '170%',
    },
  },
  'body.md': {
    value: {
      fontSize: 'sm',
      fontWeight: 'normal',
      lineHeight: '160%',
    },
  },
  'body.sm': {
    value: {
      fontSize: 'xs',
      fontWeight: 'normal',
      lineHeight: '130%',
    },
  },

  // Label styles
  'label.xl': {
    value: {
      fontSize: 'lg-xl',
      fontWeight: 'bold',
      lineHeight: '100%',
    },
  },
  'label.lg': {
    value: {
      fontSize: 'md',
      fontWeight: 'bold',
      lineHeight: '100%',
    },
  },
  'label.md': {
    value: {
      fontSize: 'sm',
      fontWeight: 'bold',
      lineHeight: '100%',
    },
  },
  'label.sm': {
    value: {
      fontSize: 'xs',
      fontWeight: 'bold',
      lineHeight: '100%',
    },
  },
});
